module.exports = __webpack_public_path__ + "static/media/cluster-and-legend.22ab987b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/maps/cluster-and-legend.png
// module id = 1256
// module chunks = 0